import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import config from '../config';

const useTools = () => {

    const {allowedActions} = useVerifiedPermissions();

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteTestingPersona)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateTestingPersona)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
